export default __webpack_public_path__ + "static/DSC01738-9c011d80c45be9217beffd442b7a35e6.webp";